var map = {
	"./cnv.png": 69,
	"./firefly.png": 142,
	"./kolam.png": 687,
	"./pytag.png": 837,
	"./rootflow.gif": 270,
	"./shareboost.jpg": 394,
	"./ytback.webp": 297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 881;